import { t as _objectSpread2 } from "./objectSpread2-CtW7yo8J.js";
import { t as getKeyboardShortcuts } from "./keyboardShortcuts-DzTQO20k.js";
import { n as isAppleDevice, t as ACTION_KEY_DEFAULT } from "./keyboard-BkSdCzTU.js";
import { t as SearchIcon } from "./SearchIcon-DbxRKLtx.js";
import { t as _objectWithoutProperties } from "./objectWithoutProperties-mN58NJZT.js";
import React, { useEffect, useState } from "react";
import { useTheme } from "@docsearch/core/useTheme";

//#region src/hooks/usePlatformKeys.ts
function usePlatformKeys() {
	const [key, setKey] = useState(null);
	useEffect(() => {
		if (typeof navigator !== "undefined") isAppleDevice() ? setKey("⌘") : setKey(ACTION_KEY_DEFAULT);
	}, []);
	const [actionKeyReactsTo, actionKeyAltText, actionKeyLabel] = key === "Ctrl" ? [
		"Control",
		"Control",
		"Ctrl"
	] : [
		"Meta",
		"Meta",
		"⌘"
	];
	return {
		actionKeyReactsTo,
		actionKeyAltText,
		actionKeyLabel,
		key
	};
}

//#endregion
//#region src/DocSearchButton.tsx
const _excluded = ["translations", "keyboardShortcuts"];
const DocSearchButton = React.forwardRef((_ref, ref) => {
	let { translations = {}, keyboardShortcuts } = _ref, props = _objectWithoutProperties(_ref, _excluded);
	const { buttonText = "Search", buttonAriaLabel = "Search" } = translations;
	const resolvedShortcuts = getKeyboardShortcuts(keyboardShortcuts);
	const { actionKeyReactsTo, actionKeyAltText, actionKeyLabel, key } = usePlatformKeys();
	useTheme({ theme: props.theme });
	const isCtrlCmdKEnabled = resolvedShortcuts["Ctrl/Cmd+K"];
	const shortcut = `${actionKeyAltText}+k`;
	return /* @__PURE__ */ React.createElement("button", _objectSpread2(_objectSpread2({
		type: "button",
		className: "DocSearch DocSearch-Button",
		"aria-label": isCtrlCmdKEnabled ? `${buttonAriaLabel} (${shortcut})` : buttonAriaLabel,
		"aria-keyshortcuts": isCtrlCmdKEnabled ? shortcut : void 0
	}, props), {}, { ref }), /* @__PURE__ */ React.createElement("span", { className: "DocSearch-Button-Container" }, /* @__PURE__ */ React.createElement(SearchIcon, null), /* @__PURE__ */ React.createElement("span", { className: "DocSearch-Button-Placeholder" }, buttonText)), /* @__PURE__ */ React.createElement("span", { className: "DocSearch-Button-Keys" }, key !== null && isCtrlCmdKEnabled && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DocSearchButtonKey, { reactsToKey: actionKeyReactsTo }, actionKeyLabel), /* @__PURE__ */ React.createElement(DocSearchButtonKey, { reactsToKey: "k" }, "K"))));
});
function DocSearchButtonKey({ reactsToKey, children }) {
	const [isKeyDown, setIsKeyDown] = useState(false);
	useEffect(() => {
		if (!reactsToKey) return;
		function handleKeyDown(e) {
			if (e.key === reactsToKey) setIsKeyDown(true);
		}
		function handleKeyUp(e) {
			if (e.key === reactsToKey || e.key === "Meta") setIsKeyDown(false);
		}
		window.addEventListener("keydown", handleKeyDown);
		window.addEventListener("keyup", handleKeyUp);
		return () => {
			window.removeEventListener("keydown", handleKeyDown);
			window.removeEventListener("keyup", handleKeyUp);
		};
	}, [reactsToKey]);
	return /* @__PURE__ */ React.createElement("kbd", { className: "DocSearch-Button-Key" + (reactsToKey === "Control" ? " DocSearch-Button-Key--ctrl" : "") + (isKeyDown ? " DocSearch-Button-Key--pressed" : "") }, children);
}

//#endregion
export { DocSearchButton as t };
//# sourceMappingURL=DocSearchButton-Dsyz7dkV.js.map